import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space1, colorText, colorTextMedium } = theme();

  return StyleSheet.create({
    featureLabel: {
      color: colorText,
    },
    featureValue: {
      color: colorTextMedium,
    },
    itemMargin: {
      marginBottom: space1,
    },
  });
};

export { style };
